import { Component } from '@angular/core';

@Component({
  selector: 'my-busy-loader',
  template: require('./busy-loader.component.html'),
  styles: [require('./busy-loader.component.scss')]
})

export class BusyLoaderComponent {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/shared/busy-loader/busy-loader.component.ts